import { render, staticRenderFns } from "./StaffTargetsCard.vue?vue&type=template&id=280d6540"
import script from "./StaffTargetsCard.vue?vue&type=script&lang=js"
export * from "./StaffTargetsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports